import React, {Component} from "react";
import SimpleCheckBox from "../../../../../../modules/SimpleCheckBox";
import FlexView from "react-flexview";
import SimpleTextArea from "../../../../../../modules/simpleTextArea";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {fetchDataAsync} from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import {HttpStatus} from "../../../../../common/Constants";
import {mapToObjectDDL} from "../../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";

class tabDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BUYER_ADDRESS: false,
            OWNER_ADDRESS: false,
            OTHERS: false,
            provinceOptions: [],
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const provinceOptions = [];
        const res = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllProvince,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: null,
            }),
        ]);

        res.forEach((response, idx) => {
            if (idx === 0) {
                if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    provinceOptions.push(...response.data.data.map(
                        d => mapToObjectDDL(d.provinceName, d.id))
                    )
                }
            }
        });

        this.setState((prevState) => ({
            ...prevState,
            provinceOptions,
            [this.props.data.dataDelivery?.alamatType?.value]: true
        }));

        this.handleTriggerLoading();
    }

    onValueChange = (tab, name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data : {
                ...prevState.data,
                [tab] : {
                    ...prevState.data[tab],
                    [name] : value
                }
            }
        }))
    }

    handleValueCheckBox = (name, value) => {
        const {tab} = this.props;
        // this.setState((prevState) => ({
        //     ...prevState,
        //     BUYER_ADDRESS: name === "BUYER_ADDRESS" && value,
        //     OWNER_ADDRESS: name === "OWNER_ADDRESS" && value,
        //     OTHERS: name === "OTHERS" && value,
        // }))

        const {patokan, catatan} = this.props.data.dataDelivery;

        if (name === "BUYER_ADDRESS" && value) {
            const pembeli = this.props.data.dataPembeli;
            this.onValueChange(tab, "alamatType", "BUYER_ADDRESS");
            this.onValueChange(tab, "alamat", pembeli?.address);
            this.onValueChange(tab, "province", pembeli?.province);
            this.onValueChange(tab, "kabKot", pembeli?.kabkot);
            this.onValueChange(tab, "kecamatan", pembeli?.kecamatan);
            this.onValueChange(tab, "kelurahan", pembeli?.kelurahan);
            this.onValueChange(tab, "kodePos", pembeli?.zipCode);
            this.onValueChange(tab, "patokan", patokan);
            this.onValueChange(tab, "catatan", catatan);
        } else if (name === "OWNER_ADDRESS" && value) {
            const pemilik = this.props.data.dataPemilik;
            this.onValueChange(tab, "alamatType", "OWNER_ADDRESS");
            this.onValueChange(tab, "alamat", pemilik?.address);
            this.onValueChange(tab, "province", pemilik?.province);
            this.onValueChange(tab, "kabKot", pemilik?.kabkot);
            this.onValueChange(tab, "kecamatan", pemilik?.kecamatan);
            this.onValueChange(tab, "kelurahan", pemilik?.kelurahan);
            this.onValueChange(tab, "kodePos", pemilik?.zipCode);
            this.onValueChange(tab, "patokan", patokan);
            this.onValueChange(tab, "catatan", catatan);
        } else if (name === "OTHERS" && value) {
            this.onValueChange(tab, "alamatType", "OTHERS");
            this.onValueChange(tab, "alamat", null);
            this.onValueChange(tab, "province", null);
            this.onValueChange(tab, "kabKot", null);
            this.onValueChange(tab, "kecamatan", null);
            this.onValueChange(tab, "kelurahan", null);
            this.onValueChange(tab, "kodePos", null);
            this.onValueChange(tab, "patokan", null);
            this.onValueChange(tab, "catatan", null);
        }
    }

    getValue = (key) => {
        const {tab} = this.props
        return this.props.data?.[tab]?.[key] || null;
    }

    getValueCheckBox = (key) => {
        const {tab} = this.props
        return this.props.data?.[tab]?.alamatType === key || false;
    }

    handleChangeProvince = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.onValueChange(tab, "kabKot", null);
        this.onValueChange(tab, "kecamatan", null);
        this.onValueChange(tab, "kelurahan", null);
        this.onValueChange(tab, "kodePos", null);
        this.onValueChange(tab, name, value);
        if (value) {
            await this.fetchKotaOptions(value.value);
        }
    };

    handleChangeKota = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.onValueChange(tab, "kecamatan", null);
        this.onValueChange(tab, "kelurahan", null);
        this.onValueChange(tab, "kodePos", null);
        this.onValueChange(tab, name, value);
        if (value) {
            await this.fetchKecamatanOptions(value.value);
        }
    };

    handleChangeKecamatan = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            kelurahanOptions: [],
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.onValueChange(tab, "kelurahan", null);
        this.onValueChange(tab, "kodePos", null);
        this.onValueChange(tab, name, value);
        if (value) {
            await this.fetchKelurahanOptions(value.value);
        }
    };

    handleChangeKelurahan = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.onValueChange(tab, "kodePos", null);
        this.onValueChange(tab, name, value);
        if (value) {
            await this.fetchZipCodeOptions(value.value);
        }
    };

    fetchKotaOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kotaOptions: response.data.data.map((option) =>
                    mapToObjectDDL(option.kabKotName, option.kabKotId)
                ),
            }));
        }
    };

    fetchKecamatanOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kecamatanOptions: response.data.data.map((option) =>
                    mapToObjectDDL(option.kecamatanName, option.id)
                ),
            }));
        }
    };

    fetchKelurahanOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kelurahanOptions: response.data.data.map((option) => ({
                    ...mapToObjectDDL(option.kelurahanname, option.id),
                })),
            }));
        }
    };

    fetchZipCodeOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getKelurahanById,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                zipCodeOptions: [mapToObjectDDL(response.data.data.zipcode, response.data.data.zipcode)],
            }));
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    isReadOnly = (name) => {
        if (this.props.state.isEditable) {
            const {alamatType} = this.props.data.dataDelivery;
            if (alamatType === "OTHERS") {
                return false;
            }

            if (name === "catatan" || name === "patokan") {
                return false;
            }
        }

        return true;
    }

    render() {
        const {tab} = this.props;
        return (
            <>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <div className="margin-5px">
                            <div className="txt-site txt-16 txt-main txt-bold">
                                <h4>Alamat Pengiriman</h4>
                            </div>
                        </div>
                        <FlexView style={{gap: 20}}>
                            <SimpleCheckBox
                                id="input_check_box_alamat_pembeli"
                                name="BUYER_ADDRESS"
                                label="Alamat Pembeli"
                                disabled={!this.props.state.isEditable}
                                checked={this.getValueCheckBox("BUYER_ADDRESS")}
                                onChange={({target}) =>
                                    this.handleValueCheckBox(target.name, target.checked)
                                }
                            />
                            <SimpleCheckBox
                                id="input_check_box_alamat_pemilik"
                                name="OWNER_ADDRESS"
                                label="Alamat Pemilik"
                                disabled={!this.props.state.isEditable}
                                checked={this.getValueCheckBox("OWNER_ADDRESS")}
                                onChange={({target}) =>
                                    this.handleValueCheckBox(target.name, target.checked)
                                }
                            />
                            <SimpleCheckBox
                                id="input_check_box_alamat_lainnya"
                                name="OTHERS"
                                label="Lainnya"
                                disabled={!this.props.state.isEditable}
                                checked={this.getValueCheckBox("OTHERS")}
                                onChange={({target}) =>
                                    this.handleValueCheckBox(target.name, target.checked)
                                }
                            />
                        </FlexView>
                        <SimpleTextArea
                            id="input_text_alamat"
                            name="alamat"
                            label="Alamat"
                            mandatory
                            errorMessage={this.props.errors?.[tab]?.alamat}
                            value={this.getValue("alamat")}
                            readOnly={this.isReadOnly()}
                            onChange={({target}) => this.onValueChange(tab, target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_provinsi"
                            name="province"
                            label="Provinsi"
                            box="search"
                            isClearable
                            mandatory
                            errorMessage={this.props.errors?.[tab]?.kodeProvinsi}
                            readOnly={this.isReadOnly()}
                            options={this.state.provinceOptions}
                            value={this.getValue("province")}
                            onChange={(value, {name}) => this.handleChangeProvince(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kota"
                            name="kabKot"
                            label="Kota"
                            box="search"
                            isClearable
                            mandatory
                            errorMessage={this.props.errors?.[tab]?.kodeKabkot}
                            readOnly={this.isReadOnly()}
                            options={this.state.kotaOptions}
                            value={this.getValue("kabKot")}
                            onChange={(value, {name}) => this.handleChangeKota(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kecamatan"
                            name="kecamatan"
                            label="Kecamatan"
                            box="search"
                            isClearable
                            mandatory
                            errorMessage={this.props.errors?.[tab]?.kodeKecamatan}
                            readOnly={this.isReadOnly()}
                            options={this.state.kecamatanOptions}
                            value={this.getValue("kecamatan")}
                            onChange={(value, {name}) => this.handleChangeKecamatan(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kelurahan"
                            name="kelurahan"
                            label="Kelurahan"
                            box="search"
                            isClearable
                            mandatory
                            errorMessage={this.props.errors?.[tab]?.kodeKelurahan}
                            readOnly={this.isReadOnly()}
                            options={this.state.kelurahanOptions}
                            value={this.getValue("kelurahan")}
                            onChange={(value, {name}) => this.handleChangeKelurahan(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kode_pos"
                            name="kodePos"
                            label="Kode Pos"
                            box="search"
                            isClearable
                            errorMessage={this.props.errors?.[tab]?.kodePos}
                            readOnly={this.isReadOnly()}
                            options={this.state.zipCodeOptions}
                            value={this.getValue("kodePos")}
                            onChange={(value, {name}) => this.onValueChange(tab, name, value)}
                        />
                        <SimpleTextArea
                            id="input_text_catatan"
                            name="patokan"
                            label="Patokan"
                            readOnly={this.isReadOnly("patokan")}
                            value={this.getValue("patokan")}
                            onChange={({target}) => this.onValueChange(tab, target.name, target.value)}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleTextArea
                            id="input_text_catatan"
                            name="catatan"
                            label="Catatan"
                            readOnly={this.isReadOnly("catatan")}
                            value={this.getValue("catatan")}
                            onChange={({target}) => this.onValueChange(tab, target.name, target.value)}
                        />
                    </div>
                </div>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

export default tabDelivery;